import React, { useEffect, useState } from "react";
import { Routes, Route, Link, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import useStore from "../../services/store";

import Overview from "./overview";
import Profitability from "./profitability";
import Forecast from "./forecast";
import TjmCheck from "./tjm-check";
import SelectUser from "../../components/selectUser";

const Piloting = () => {
  const [user, setUser] = useState(null);
  const [filters, setFilters] = useState({
    manageesOfManagees: false,
    excludeUserId: null,
  });

  // Get organisation + business unit from Zustand store
  const organisation = useStore((state) => state.organisation);
  const businessUnit = useSelector((state) => state.Auth.businessUnit);

  return (
    <div className="">
      <div className="border-b border-gray-200 mb-6 flex justify-between items-center">
        <nav className="flex flex-1 gap-1">
          <TabItem href="/piloting" title="Overview" exact />
          <TabItem href="/piloting/profitability" title="Profitability" />
          <TabItem href="/piloting/forecast" title="Forecast P&L" />
          <TabItem href="/piloting/tjm-check" title="TJM Check" />
        </nav>
        <div className="flex items-center gap-4">
          {user && (
            <label className="flex items-center gap-2 text-sm text-gray-600 cursor-pointer">
              <input
                type="checkbox"
                checked={filters.manageesOfManagees}
                onChange={(e) => setFilters({ ...filters, manageesOfManagees: e.target.checked })}
                className="rounded border-gray-300 text-blue-600 focus:ring-blue-500"
              />
              <span>Include managees of managees</span>
            </label>
          )}

          <div className="flex items-center gap-2">
            <SelectUser 
              className="w-full" 
              value={user} 
              onChange={(user) => setUser(user)} 
              userRoles={["admin", "user", "super_admin"]}
              placeholder="Filter by manager..."
            />
            {user && (
              <button
                onClick={() => setUser(null)}
                className="text-xs px-2 py-1 bg-gray-200 hover:bg-gray-300 rounded-md text-gray-600"
                title="Show whole company">
                ✕
              </button>
            )}
          </div>
        </div>
      </div>

      <Routes>
        <Route path="/" element={<Overview key={businessUnit._id} user={user} filters={filters} organisation={organisation} businessUnit={businessUnit} />} />
        <Route path="/profitability" element={<Profitability key={businessUnit._id} user={user} filters={filters} organisation={organisation} businessUnit={businessUnit} />} />
        <Route path="/forecast" element={<Forecast key={businessUnit._id} user={user} filters={filters} organisation={organisation} businessUnit={businessUnit} />} />
        <Route path="/tjm-check" element={<TjmCheck key={businessUnit._id} user={user} filters={filters} organisation={organisation} businessUnit={businessUnit} />} />
      </Routes>
    </div>
  );
};

const TabItem = ({ href, title, exact = false }) => {
  const location = useLocation();
  const [active, setActive] = useState(false);

  useEffect(() => {
    if (exact) {
      setActive(location.pathname === href);
    } else {
      setActive(location.pathname === href || location.pathname.startsWith(href + "/"));
    }
  }, [location.pathname, href, exact]);

  return (
    <Link
      to={href}
      className={`py-2 px-4 border-b-2 font-medium text-sm ${
        active ? "border-blue-500 text-blue-600" : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
      }`}>
      {title}
    </Link>
  );
};

export default Piloting;
